module.exports = __webpack_public_path__ + "img/prof.c4c7f379.png";